"use client";

import { usePathname } from "next/navigation";
import Header from "@/ui/layout/header/header";
import Footer from "@/ui/layout/footer";
import { FeedbackWidget } from "@/components/FeedbackWidget";
// Chatbot anterior desactivado: se reemplaza por el widget del portal.
// import ChatBot from "@/components/ChatBot/ChatBot";
import Script from "next/script";
import { stripLocale } from "@/i18n/config";
// import { VOICE_EMBED_ORIGIN } from "@/lib/voiceEmbed";

const EXCLUDED_ROUTES = [
  "/aeropuertos",
  "/mppa",
  "/mpda",
  "/mpsm",
  "/mantenimiento",
  "/marketplace",
  "/map",
];

interface LayoutWrapperProps {
  children: React.ReactNode;
}

export default function LayoutWrapper({ children }: LayoutWrapperProps) {
  const pathname = usePathname();

  const pathWithoutLocale = stripLocale(pathname);
  const isExcludedRoute = EXCLUDED_ROUTES.some(
    (route) =>
      pathWithoutLocale === route || pathWithoutLocale.startsWith(`${route}/`),
  );

  if (isExcludedRoute) {
    return <main className="min-h-screen">{children}</main>;
  }

  return (
    <>
      <Header />
      <main className="min-h-screen">{children}</main>
      <Footer />
      <FeedbackWidget />

      {/* Chatbot anterior (SDK de voz + widget propio ChatBot), desactivado:
          <Script
            id="inferencia-voice-embed"
            src={`${VOICE_EMBED_ORIGIN}/embed.js`}
            strategy="afterInteractive"
            data-auto-init="false"
          />

          <ChatBot />
      */}

      <Script
        id="inferencia-portal-widget"
        src="https://portal.inferencia.digital/widget.js"
        strategy="afterInteractive"
        data-key="tocumen"
        data-lang="auto"
      />
    </>
  );
}
